// Handing the user a file — history exports, .ics events, undecodable
// recordings. The browser download is the web's "save to disk".

export function downloadBytes(bytes: Uint8Array, contentType: string, filename: string): void {
  const blob = new Blob([bytes as BlobPart], { type: contentType });
  downloadBlob(blob, filename);
}

export function downloadText(text: string, contentType: string, filename: string): void {
  downloadBlob(new Blob([text], { type: contentType }), filename);
}

function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
